import { useState, useEffect } from "react";
import "reactjs-popup/dist/index.css";
import axios from "axios";
import Topbar from "../components/Topbar";
import "../css/ClassesPage.css";
import StudentGallery from "./StudentGallery";
import ArtworkMagnifier from "./ArtworkMagnifier";

// Allows teacher to view student artwork by class.
function TeacherClassroom(user) {
  const [myClasses, setMyClasses] = useState([]); // All classes the teacher teaches
  const [selectedClass, setSelectedClass] = useState(null); // HTML element representing selected class; default -1 for no class selected
  const [classStudents, setClassStudents] = useState([]); // Students from selected class
  const [selectedArtwork, setSelectedArtwork] = useState(null);

  // Get all classes that this teacher teaches
  useEffect(() => {
    axios.get("/api/teachers/" + user.id + "/classes")
    .then((response) => {
      setMyClasses(response.data);
    });
  }, []);

  // Show students from class selection and style selected class
  useEffect(() => {
    if (selectedClass) {
      // Remove selected class styling from all other classes
      let classOptions = document.getElementsByClassName("class-option");
      Array.from(classOptions).forEach(classOption => {
        classOption.classList.remove("selected-class");
      })
      // Style newly selected class
      selectedClass.classList.add("selected-class");

      // Get students from selected class
      axios.get("/api/students?class=" + selectedClass.getAttribute("data-class-id"))
      .then((response) => {
        setClassStudents(response.data);
      });
    }
  }, [selectedClass]);

  const selectClass = (event) => {
    setSelectedClass(event.target);
  }

  const selectArtwork = (event) => {
    setSelectedArtwork(event.target);
  }

  const closeArtwork = () => {
    setSelectedArtwork(null);
  }

  return(
    <div className="page">
      <Topbar isAdminPage = {false}/> {/* Navbar */}
      <div id = "main-content">
        {selectedArtwork && (
          <ArtworkMagnifier selectedArtwork={selectedArtwork} closeArtwork={closeArtwork} />
        )}
        <div className="panel" id="classes-panel"> {/* Classes panel */}
          <div id="classes-panel-header" className="panel-header"><h2>My Classes</h2></div>
          <div className="panel-content"> {/* Classes list */}
            {myClasses.map((myClass) => 
              <div className="class-option" onClick={selectClass} data-class-id={myClass.classID}>
                {myClass.className}
              </div>)}
          </div>
        </div>
        {/* Hide Students panel until a class is selected */}
        {selectedClass ? (
          <div className="panel" id="students-panel"> {/* Students panel */}
            <div id="students-panel-header" className="panel-header"><h2>{selectedClass && selectedClass.innerText}</h2></div>
            <div className="panel-content">
              {classStudents.map((student) => <StudentGallery student={student} artSelector={selectArtwork}/>)}
            </div>
          </div>
        ) : <p>To view student artwork, select a class on the left.</p>}        
      </div>
    </div>
  )
}

export default TeacherClassroom;
